export default "__VITE_ASSET__da828047__"